import { render, staticRenderFns } from "./UsernamePasswordView.vue?vue&type=template&id=16657123&scoped=true&"
import script from "./UsernamePasswordView.vue?vue&type=script&lang=js&"
export * from "./UsernamePasswordView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=16657123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16657123",
  null
  
)

export default component.exports